import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface SalesByClientsPrintingResult extends ReportPrintResult { }

export interface SalesByClientsPrintingParameters extends ReportPrintQueryParameters { }

export class SalesByClientsPrintingQuery extends ReportPrintQuery<SalesByClientsPrintingResult> {
    public constructor(parameters: SalesByClientsPrintingParameters) {
        super(parameters);
    }
}

export class SalesByClientsPrintingQueryHandlerBase implements QueryHandler<SalesByClientsPrintingQuery, SalesByClientsPrintingResult> {
    private static Url = TaggedUrl.join('salesByClients/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: SalesByClientsPrintingQuery): Promise<SalesByClientsPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                summary: parameters.summary,
                columns: parameters.columns,
                report: 'SprzedazWgKlientow'
            }
        };
        const { data } = await this.http.post<{ url: string; }>(SalesByClientsPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });

        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
